export default __webpack_public_path__ + "media/images/user/fav-c4103df7591ccd60c1ddd139fbf24326.png";